import { Box } from '@mui/system'
import { MagicSpinner } from 'react-spinners-kit'

const Loader = ({ store, transparent }) => (
  <>
    {store?.loading && (
      <Box sx={[styles.root, transparent && styles.transparent]}>
        <MagicSpinner size={100} color="#29cc8b" />
      </Box>
    )}
  </>
)

const styles = {
  root: {
    position: 'fixed',
    zIndex: 9999,
    backgroundColor: 'rgb(247 249 251 / 74%)',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  transparent: {
    backgroundColor: 'transparent',
  },
}

export default Loader
